import { cn } from '../../lib/cn';
import { Button } from '../ui';
import type { DensityMode } from '../../adaptivexp/framework';

type Props = {
  value?: DensityMode;
  onChange?: (mode: DensityMode) => void;
  className?: string;
};

const MODES: DensityMode[] = ['Compact', 'Comfortable', 'Spacious'];

export function DensityModeToggle({ value = 'Comfortable', onChange, className }: Props) {
  return (
    <div className={cn('flex gap-1 rounded-lg border border-slate-200 p-0.5 dark:border-slate-700', className)}>
      {MODES.map((m) => (
        <Button
          key={m}
          variant={value === m ? 'primary' : 'ghost'}
          size="sm"
          onClick={() => onChange?.(m)}
        >
          {m}
        </Button>
      ))}
    </div>
  );
}
